import React from 'react';

export default function ChevronDown({className}) {
	return (
		<svg className={className ? className : ''} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 7" preserveAspectRatio="xMidYMid meet"><path d="M5.5 7L0 1.441 1.426 0 5.5 4.118 9.574 0 11 1.441z"/></svg>
	);
}
